/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { getAppName } from '../lib/app'
import logo from '../../../public/logo.svg'
import { Image, ImageProps } from '@mantine/core'

function AppLogo (props: ImageProps) {
  return (
    <Image
      alt={`${getAppName()} logo`}
      fit="contain"
      h={24}
      w={24}
      {...props}
      src={logo}
    />
  )
}

export default AppLogo
